// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaCreditApplication.MaxaCreditApplication.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MaxaCreditApplication/SuiteScript2/MaxaCreditApplication.Service.ss"
            ),
            true
        )
});
});
